import Vue from 'vue';
import Router from 'vue-router';
import VueSocialSharing from 'vue-social-sharing';
import isMobile from 'ismobilejs';
import App from './App.vue';
import './filters';

import Rebate from './components/rebate';
import Safe from './components/safe';
import Header from './components/header';
import Footer from './components/footer';
import Privacy from './components/links/privacy';
import Terms from './components/links/terms';
import Reservations from './components/links/reservations';

Vue.use(VueSocialSharing);
Vue.config.productionTip = false;

Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            components: {
                default: Safe,
                rebate: Rebate,
                header: Header,
                footer: Footer
            },
            props: {
                default: true,
                rebate: true
            }
        },
        {
            path: '/:token',
            components: {
                default: Safe,
                rebate: !isMobile().any && Rebate,
                header: !isMobile().any && Header,
                footer: !isMobile().any && Footer
            },
            props: {
                default: true,
                rebate: true
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            components: {
                default: Privacy,
                header: Header,
                footer: Footer
            }
        },
        {
            path: '/terms',
            name: 'terms',
            components: {
                default: Terms,
                header: Header,
                footer: Footer
            }
        },
        {
            path: '/reservations',
            name: 'reservations',
            components: {
                default: Reservations,
                header: Header,
                footer: Footer
            }
        }
    ]
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
